import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.css';

function CookiePolicy() {
  const { t } = useTranslation();
  return (
    <div className="mvp-legal-page">
      <div className="mvp-legal-card">
        <h1>{t('legal.cookiePolicy', 'Cookie policy')}</h1>
        <p className="mvp-legal-placeholder">
          {t('legal.cookiePolicyContent', 'We use essential cookies to run the service (e.g. session, authentication) and optional cookies to improve experience. You can change your preferences at any time. For full details see our Privacy Policy.')}
        </p>
        <Link to="/" className="mvp-legal-back">{t('legal.goHome', 'Go to home')}</Link>
      </div>
    </div>
  );
}

export default CookiePolicy;
